import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import sendEmail from "./email";
// import axios from "axios";
import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import "../App.css";

import pageHeaderBg from "../assets/EPAGING-IT-ABOUT-US-BANNER.jpg";
import aboutImage from "../assets/team-work2.jpg";
import asia from "../assets/asia petroleum logo.png";
import faisal from "../assets/faisal-industries-logo.png";
import brb from "../assets/brb-engineering-logo.webp";
import istlogo from "../assets/IST logo.png";
import primerx from "../assets/PrimeRx.png";
import whyChooseImg from "../assets/rida.jpg";
import team1 from "../assets/team/team-1-1.png";
import team2 from "../assets/team/team-1-2.jpeg";
import team3 from "../assets/team/team-1-3.jpg";
import team4 from "../assets/team/junaid.jpg";

const accordionData = [
  {
    title: " Proven Expertise",
    content:
      "With nearly a decade of industry experience, our team of IT professionals delivers robust, future-ready solutions from ERP systems to cloud infrastructure and custom software development.",
    id: 1,
  },
  {
    title: " Global Reach, Local Touch",
    content:
      "With offices in Pakistan and the USA, we offer global capabilities with a personal, client-first approach. Whether you’re a local business or an international enterprise, we’re here to serve you with excellence.",
    id: 2,
  },
  {
    title: " End-to-End Services",
    content:
      "From AI agents and video intelligence to ERP, cloud infrastructure, and managed support, we offer a full spectrum of enterprise technology under one roof, simplifying your digital transformation journey.",
    id: 3,
  },
  {
    title: " 24/7 Support",
    content:
      "Your business doesn’t sleep and neither do we. Our dedicated support team ensures your systems run smoothly around the clock, minimizing downtime and maximizing productivity.",
    id: 4,
  },
];

function About() {
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    try {
      const response = await fetch("/api/send-email", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        alert("Email sent successfully!");
        formRef.current.reset(); 
      } else {
        alert("Failed to send email.");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert("An error occurred while sending the email.");
    }

    // try {
    //   const response = await axios.post(
    //     "http://localhost:5000/send-email",
    //     formData
    //   );
    //   if (response.data.success) {
    //     alert("Email sent successfully!");
    //     formRef.current.reset(); // Clear form
    //   } else {
    //     alert("Failed to send email.");
    //   }
    // } catch (error) {
    //   console.error("Error sending email:", error);
    //   alert("An error occurred.");
    // }
  };

  const brandImages = [istlogo, primerx, asia, faisal, brb, istlogo, primerx, asia, faisal, brb];

  const teamMembers = [
    {
      id: 1,
      name: "Kiran Sayed",
      role: "Head of HR",
      badge: "Executive Leadership",
      image: team1,
      delay: 100,
      linkedin:
        "https://www.linkedin.com/in/kiran-sayed-chrp-61135644?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },
    {
      id: 2,
      name: "Maheen Anser",
      role: "Head of Customer Service",
      badge: "Client Success",
      image: team2,
      delay: 200,
      linkedin:
        "https://www.linkedin.com/in/maheenanser?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },
    {
      id: 3,
      name: "Shan Ali Hussain",
      role: "Sr. Software Engineer",
      badge: "Core Engineering",
      image: team3,
      delay: 300,
      linkedin:
        "https://www.linkedin.com/in/hussainshanali/",
    },
    {
      id: 4,
      name: "Junaid Siddiqui",
      role: "Manager - IT Support",
      badge: "IT Operations",
      image: team4,
      delay: 300,
      linkedin:
        "https://www.linkedin.com/in/m-junaid-siddiqui-827674262/",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className="page-wrapper">
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <section className="page-header">
            <div
              className="page-header__bg"
              style={{ backgroundImage: `url(${pageHeaderBg})` }}
            ></div>
            <div className="container">
              <div className="page-header__content">
                <h2 className="page-header__title">About Us</h2>
                <ul className="lotech-breadcrumb list-unstyled">
                  <li>
                    <Link to="/home">Home</Link>
                  </li>
                  <li>
                    <span>About Us</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="about-one">
            <div className="container"
            data-aos="zoom-in-down"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <div className="row">
                <div className="col-xl-6 d-flex align-items-center">
                  {/* Content Section */}
                  <div className="about-one__content">
                    <div className="sec-title text-left">
                      <h6 className="sec-title__tagline bw-split-text">
                        Our About Us
                      </h6>
                      <h3 className="sec-title__title bw-split-text">
                        We build AI-first enterprise technology that helps
                        companies grow.
                      </h3>
                      <p className="about-us-text-1">
                        ​Epaging Pvt Ltd., established in 2015 in Karachi,
                        Pakistan, is an enterprise technology partner
                        dedicated to helping businesses align AI, infrastructure
                        and operations with their strategic goals. With a global
                        presence, including an office in Somerset, New Jersey,
                        USA, Epaging offers a wide array of solutions tailored
                        to meet diverse business needs.
                      </p>
                    </div>

                    <div className="about-one__box">
                      <div className="about-one__box__icon">
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                      <div>
                        <h5 className="about-one__box__title">Our Mission</h5>
                        <p className="about-one__box__text">
                          Our mission is to deliver reliable, scalable, and
                          cutting-edge IT services that help businesses achieve
                          their digital transformation goals. We are committed
                          to excellence, agility, client satisfaction and
                          partnership - driving success through technology and
                          trust.
                        </p>
                      </div>
                    </div>

                    <div className="about-one__box">
                      <div className="about-one__box__icon">
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                      <div>
                        <h5 className="about-one__box__title">Our Vision</h5>
                        <p className="about-one__box__text">
                          To be a trusted global leader in IT services,
                          empowering businesses through innovative technology
                          solutions, seamless integration, transformative
                          digital and exceptional client experiences.
                        </p>
                      </div>
                    </div>

                    <div className="about-one__content__btn">
                      <a href="/solutions" className="lotech-btn">
                        <span>
                          Explore Our Solutions
                          <span className="lotech-btn__icon">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </span>
                      </a>
                      {/* <div className="about-one__content__author">
                        <img src={authorImage} alt="lotech" />
                        <div className="about-one__content__author__content">
                          <h5 className="about-one__content__author__name">
                            Esther Howard
                          </h5>
                          <p className="about-one__content__author__text">
                            JR Designer
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* Image Section */}
                <div className="col-xl-6 text-end">
                  <div
                    className="about-one__image"
                    data-speed="1.1"
                    data-lag="0"
                  >
                    <img src={aboutImage} alt="epaging" />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="client-carousel">
            <div
              className="container"
              data-aos="zoom-out-down"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <p className="client-carousel__title">2K Brands Trust Us</p>
              <Swiper
                modules={[Autoplay, Pagination]}
                navigation={false}
                pagination={{ clickable: false }}
                spaceBetween={65}
                slidesPerView={5}
                loop={true}
                autoplay={{ delay: 6000, disableOnInteraction: false }}
                breakpoints={{
                  0: { slidesPerView: 1, spaceBetween: 0 },
                  360: { slidesPerView: 2, spaceBetween: 30 },
                  575: { slidesPerView: 3, spaceBetween: 30 },
                  768: { slidesPerView: 4, spaceBetween: 40 },
                  992: { slidesPerView: 4, spaceBetween: 40 },
                  1200: { slidesPerView: 5, spaceBetween: 80 },
                }}
                className="client-carousel__one"
              >
                {brandImages.map((src, index) => (
                  <SwiperSlide
                    key={index}
                    className="client-carousel__one__item"
                  >
                    <img src={src} alt={`Brand ${index + 1}`} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          <section className="team-one">
            <div className="container">
              <div className="sec-title text-center">
                <h6 className="sec-title__tagline bw-split-text">
                  Meet Our Team
                </h6>
                <h3 className="sec-title__title bw-split-text">
                  Our Successful Team Members
                </h3>
              </div>

              <div className="row gutter-x-24 gutter-y-30 justify-content-center">
                {teamMembers.map((member) => (
                  <div key={member.id} className="col-6 col-lg-3">
                    <div
                      className="team-card"
                      data-aos="fade-up"
                      data-aos-anchor-placement="top-center"
                      data-aos-duration="1300"
                      data-aos-delay={member.delay}
                      data-aos-once="true"
                    >
                      <div className="team-card__image">
                        <img src={member.image} alt={member.name} />
                        <span className="team-card__badge">{member.badge}</span>
                        <div className="team-card__social">
                          <a
                            href={member.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-linkedin" aria-hidden="true"></i>
                            <span className="sr-only"></span>
                          </a>
                        </div>
                      </div>

                      <div className="team-card__content">
                        <h3 className="team-card__title">{member.name}</h3>
                        <p className="team-card__designation">{member.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="why-choose-one">
            <div className="container">
              <div className="row d-flex align-items-end">
                <div className="col-lg-6">
                  <div className="sec-title text-left">
                    <h6 className="sec-title__tagline bw-split-text">
                      Why Work with
                    </h6>
                    <h3 className="sec-title__title bw-split-text">
                      EPAGING
                    </h3>
                  </div>
                  <div
                    className="why-choose-one__image"
                    data-speed="1.1"
                    data-lag="0"
                  >
                    <img src={whyChooseImg} alt="epaging" />
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="flip-down"
                  data-aos-duration="1400"
                  data-aos-delay="200"
                >
                  <div className="why-choose-one__accordion lotech-accrodion">
                    <p className="contact-three__wrapper__text text-splite-up"></p>
                    <form
                      ref={formRef}
                      onSubmit={handleSubmit}
                      encType="multipart/form-data"
                      className="contact-three__form contact-form-validated form-one"
                      data-aos="fade-up"
                      data-aos-duration="1200"
                      data-aos-delay="300"
                    >
                      <div className="form-one__group">
                        <div className="form-one__control">
                          <input
                            type="text"
                            name="first_name"
                            placeholder="First Name*"
                            required
                          />
                        </div>
                        <div className="form-one__control">
                          <input
                            type="text"
                            name="last_name"
                            placeholder="Last Name*"
                            required
                          />
                        </div>
                        <div className="form-one__control">
                          <input
                            type="email"
                            name="email"
                            placeholder="E-mail*"
                            required
                          />
                        </div>

                        <div className="form-one__control">
                          <input
                            type="text"
                            name="address"
                            placeholder="Address*"
                            required
                          />
                        </div>
                        <div className="form-one__control">
                          <input
                            type="text"
                            name="city"
                            placeholder="City*"
                            required
                          />
                        </div>
                        <div className="form-one__control">
                          <input
                            type="text"
                            name="pincode"
                            placeholder="Pincode*"
                            required
                          />
                        </div>

                        <div className="form-one__control">
                          <input
                            type="tel"
                            name="phone"
                            placeholder="Phone Number*"
                            required
                          />
                        </div>
                        <div className="form-one__control">
                          <select name="job_role" required>
                            <option value="">Select Job Role*</option>
                            <option value="technicalsupport">Technical Support</option>
                            <option value="csr">Customer Service Representative</option>
                             <option value="graphicdesigner">Graphic Designer</option>
                            <option value="fullstack">
                              Full Stack Developer
                            </option>
                           
                          </select>
                        </div>

                        <div className="form-one__control">
                          <input
                            type="date"
                            name="date"
                            placeholder="Date*"
                            required
                          />
                        </div>
                        <div className="form-one__control form-one__control--full">
                          <input
                            type="file"
                            name="cv"
                            accept=".pdf,.doc,.docx"
                            required
                          />
                        </div>
                        <div className="form-one__control form-one__control--full">
                          <button type="submit" className="lotech-btn">
                            <span>
                              Apply Now
                              <span className="lotech-btn__icon">
                                <i className="flaticon-up-right-arrow"></i>
                                <i className="flaticon-up-right-arrow"></i>
                              </span>
                            </span>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default About;
